import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { DfApiConfigService } from '@df/api/config/df-api-config.service';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { App } from '@df/core/app';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { PriceComponent } from '@df/ui/price/price.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentField } from '@icms/core/content';
import sortBy from 'lodash-es/sortBy';

export namespace NProductViewSurchargeModal {
    export const BLOCK_ID = 'product-surcharge-modal';

    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    export interface IBlockData extends Catalog.IBlockData<IBlockDataContent> {}

    export interface IBlockDataContent {
        copy: string;
        ctaCopy: string;
    }

    export interface IModalData {
        // surcharge attribute value
        surcharge: number;
    }

    export enum ELayout {
        bundle,
        default
    }

    export interface ISurchargeTableItem {
        country: string;
        price: number;
    }
}
export type TSurchargeData = {
    category_id: number;
    delivery_country: string[] | string;
    price: number;
}[];

@DfCmsModal({
    id: NProductViewSurchargeModal.BLOCK_ID,
    name: 'Product surcharge information',
    config: {
        width: '340px',
        maxWidth: '90vw'
    },
    blockGroup: 'modals',
    priority: 20,
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: sizeId => ['S', 'M', 'L', 'X']
})
@ICmsComponent<ProductViewSurchargeModalComponent>({
    id: NProductViewSurchargeModal.BLOCK_ID,
    block: {
        url: NProductViewSurchargeModal.BLOCK_ID
    },
    name: 'Product surcharge information',
    description: 'List of surcharges matching surcharge of selected product',
    onDemandOnly: true,
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'label-general',
            title: 'General'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'copy',
            title: 'Top content',
            required: true
        }
    ]
})
@Component({
    selector: 'product-view-surcharge-modal',
    templateUrl: './product-view-surcharge-modal.html',
    standalone: true,
    imports: [ICmsClientModule, PriceComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewSurchargeModalComponent extends UiComponent implements OnInit {
    protected surchargeTable: NProductViewSurchargeModal.ISurchargeTableItem[] = [];

    @ICmsContent({
        type: 'blockContent'
    })
    content?: NProductViewSurchargeModal.IBlockDataContent;

    constructor(
        private app: App,
        private dfApiConfigService: DfApiConfigService,
        @Inject(MODAL_DATA) private data: NProductViewSurchargeModal.IModalData,
        private modalRef: ModalRef<ProductViewSurchargeModalComponent>,
        private cdr: ChangeDetectorRef
    ) {
        super();
    }

    override async ngOnInit() {
        await this.dfApiConfigService.loadCountries();
        this.updateSurchargeTable();
        super.ngOnInit();
    }

    protected close() {
        this.modalRef.close();
    }

    private updateSurchargeTable() {
        const surchargeId = this.data.surcharge;
        const items = ((this.app.apiConfigService._countries as any).surcharge_data as TSurchargeData) || [];
        const matchingItems = surchargeId ? items.filter(i => i.category_id === surchargeId) : items;
        const countries = this.app.apiConfigService.countries || [];
        const surchargeTable: NProductViewSurchargeModal.ISurchargeTableItem[] = [];
        matchingItems.forEach(item => {
            const items = typeof item.delivery_country === 'string' ? JSON.parse(item.delivery_country) : item.delivery_country;
            items.forEach(countryCode => {
                const country = countries.find(i => i.code === countryCode);
                surchargeTable.push({
                    country: country?.name || countryCode,
                    price: item.price
                });
            });
        });

        this.surchargeTable = sortBy(surchargeTable, 'country');
        this.cdr.detectChanges();
    }
}
